angular.module('unergie.main').directive('salesTunnelQuotation', ($q, $rootScope, $timeout, MetaWatcher, ApiUser, Tariff, ReferencesService, Landscape,
    EstimateTimetableService, BoFeaturesService, ErrorCatcher, TimetableGeneration, AlertManager) => ({
        restrict: 'E',
        scope: {
            draft: '=',
            prm: '=',
            landscape: '=',
            disableContractEdition: '=',
        },
        templateUrl: '/states/salesTunnelV2/component/salesTunnelQuotation.html',
        link($scope) {
            $scope.canImportLandscape = BoFeaturesService.getModuleFeatures('contracts').canImportLandscape
            $scope.canSeeOldLandscape = BoFeaturesService.getModuleFeatures('contracts').canSeeOldLandscape
            $scope.landscapeDefaultSource = BoFeaturesService.get('isEnvProd') ? '' : 'CTWMRURN6'
            $scope.showTimetableGraph = false
            $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
            $scope.fetchingLandscapeRequirement = false
            $scope.cons = {}
            $scope.prm_last_update = null
            $scope.showTimetableActions = BoFeaturesService.isFeatureOn('showTimetableActions')
            $scope.simulations = {
                simulationResult: {},
                refResult: {},
                simulationMinus5: {},
                simulationMinus10: {},
                simulationMinus15: {},
            }
            $scope.reduction = {
                value: 5,
            }

            $scope.PREFERRED_ESTIMATOR_MAPPING = {
                AVERAGED_CONS: 'averaged',
                DECLARED_CONS: 'declared',
                CONS_MEASURE: 'measure',
                null: 'default',
            }

            // REFS
            $scope.preferredDays = []
            ReferencesService.getRef('pref-payment-days').then((mapping) => {
                $scope.preferredDays = (_.range(mapping.MIN, mapping.MAX + 1).map((num) => num))
            })

            // VALIDATORS
            const initComponentValidator = () => {
                MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                    isLandscapeValid(store) {
                        return !!store.draft.bulk_purchase || (store.landscape.landscapeRequired === false) || (store.landscape.landscapeDone === true)
                    },
                    isPromoCodeValid(store) {
                        return _.isEmpty(store.prm.promoErrorMessage)
                    },
                    isPreferredPaymentDayValid(store) {
                        return $scope.preferredDays.indexOf(store.draft.preferred_payment_day) > -1
                    },
                })
            }

            $scope.saveLandscape = function (payload) {
                $scope.landscape = _.assign({}, $scope.landscape, payload)
                MetaWatcher.notif('SALES_TUNNEL.SAVE_LANDSCAPE', payload)
            }

            $scope.saveSubscriptionPrice = function (payload) {
                $scope.simulations = _.assign({}, {
                    simulationResult: {},
                    refResult: {},
                    simulationMinus5: {},
                    simulationMinus10: {},
                    simulationMinus15: {},
                }, payload)
                MetaWatcher.notif('SALES_TUNNEL.SUBSCRIPTION_PRICE', $scope.simulations)
            }

            // CHECK LANDSCAPE & CHECK SIMULATE
            const checkLandscapeRequired = function () {
                $scope.fetchingLandscapeRequirement = true
                return ApiUser.checkLandscapeRequired({ idContract: $scope.draft.id, draft: true }).$promise.finally(() => {
                    $scope.fetchingLandscapeRequirement = false
                })
            }

            const readyToEstimate = function () {
                const isNotFetchingLandscapeRequirement = (!$scope.fetchingLandscapeRequirement)
                const isLandscapeValid = ($scope.landscape.landscapeRequired === false) || ($scope.landscape.landscapeDone)
                const isMaxPowerDefined = !!($scope.draft.max_power || $scope.draft.choosen_max_power)
                const isIDPCalendarDefined = !!($scope.draft.id_p_calendar || $scope.draft.choosen_id_p_calendar)

                return isNotFetchingLandscapeRequirement && (isLandscapeValid || $scope.draft.bulk_purchase) && isMaxPowerDefined && isIDPCalendarDefined
            }

            const getEstimatedForEstimator = (estimator) => {
                return ApiUser.draftEstimatedV2({ idContract: $scope.draft.id, estimator }, { timePeriod: { endDate: '13-month-trunc' } }).$promise.then((rawEstimated) => {
                    const estimated = rawEstimated.toJSON()
                    const esti = estimator || ($scope.draft.bulk_purchase && $scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]) || 'default'
                    $scope.cons[esti] = estimated
                    return Math.round(_.sum(_.values($scope.cons[esti].annual)))
                })
                .catch(ErrorCatcher)
            }

            const fetchAnnualCons = function () {
                $scope.cons = {}
                $scope.saveSubscriptionPrice({})
                if ($scope.draft.bulk_purchase && !$scope.landscape.landscapeRequired) {
                    return $q.all({
                        averaged: getEstimatedForEstimator('averaged'),
                        measure: getEstimatedForEstimator('measure'),
                        declared: getEstimatedForEstimator('declared'),
                    }).then((estimators) => {
                        MetaWatcher.notif('SALES_TUNNEL.MODIFIED_ESTIMATED_CONS', estimators)
                    })
                }
                return getEstimatedForEstimator()
            }

            $scope.onDraftUpdated = function (draftState, previousDraftState) {
                const areDefined = (...listField) => listField.every((field) => !_.isNil(_.get(draftState, field)))
                const hasDifference = (...listField) => listField.some((field) => (_.get(draftState, field) !== _.get(previousDraftState, field)))

                const isDraftFieldDefined = areDefined('is_a_move', 'id_prm') && $scope.prm.eligible
                const isDraftFieldChanged = hasDifference('is_a_move', 'id_prm', 'heating', 'primary_residence')
                const isOfferFieldChanged = hasDifference('max_power', 'choosen_max_power', 'id_p_calendar', 'choosen_id_p_calendar')
                const isPrmUpdated = $scope.prm.eligible && $scope.prm.last_update !== $scope.prm_last_update
                $scope.prm_last_update = $scope.prm.last_update

                // Check to execute landscape or reset data
                if ($scope.disableContractEdition && $scope.draft.providerOffer) {
                    $scope.checkLandscape()
                } else if (isDraftFieldDefined) {
                    if (isDraftFieldChanged || ($scope.landscape.landscapeRequired === null)) {
                        $scope.saveLandscape({ landscapeRequired: null })
                        $scope.saveSubscriptionPrice({})
                    }
                    if ($scope.canLandscape() && (isDraftFieldChanged || isOfferFieldChanged || isPrmUpdated)) {
                        $scope.checkLandscape()
                    }
                }
                else {
                    $scope.saveLandscape({ landscapeRequired: null })
                    $scope.saveSubscriptionPrice({})
                }
            }

            $scope.$watch('draft', $scope.onDraftUpdated)

            $scope.checkLandscape = () => {
                checkLandscapeRequired().then((landscapeRequirement) => {
                    const landscapeRequired = ($scope.draft.is_a_move || landscapeRequirement.required)
                    $scope.saveLandscape({ landscapeRequired })
                    if (landscapeRequired && $scope.draft.bulk_purchase && $scope.draft.preferred_estimator !== 'DECLARED_CONS') {
                        $scope.saveDraft({ preferred_estimator: 'DECLARED_CONS' })
                    }
                    $scope.estimate()
                })
            }

            $scope.estimate = function () {
                // Execute only after landscape checked
                if (readyToEstimate()) {
                    fetchAnnualCons().then(() => {
                        $scope.fetching = false
                        $scope.simulate()
                    })
                } else {
                    $scope.fetching = false
                }
            }

            // LANDSCAPE
            $scope.canLandscape = function () {
                const isPrmEligible = $scope.prm.eligible
                const isMaxPowerDefined = !!($scope.draft.max_power || $scope.draft.choosen_max_power)
                const isIdPCalendarDefined = !!($scope.draft.id_p_calendar || $scope.draft.choosen_id_p_calendar)
                return isPrmEligible && isMaxPowerDefined && isIdPCalendarDefined && !$scope.disableContractEdition
            }

            const onLandscapeChanged = (result = {}) => {
                if (result.heating) {
                    $scope.draft.heating = result.heating
                }
                if (_.isBoolean(result.primary_residence)) {
                    $scope.draft.primary_residence = result.primary_residence
                }
                $scope.saveLandscape({ landscapeDone: !!result.landscapeDone, landscapeVersion: result.landscapeVersion })
                if ($scope.landscape.landscapeRequired) {
                    $scope.estimate()
                }
            }

            $scope.onLandscapeImported = (result) => {
                onLandscapeChanged(_.assign({}, result, { landscapeDone: true, landscapeVersion: result.version }))
            }

            $scope.openLandscape = function (display = false, openNewLandscape = false) {
                if (openNewLandscape) {
                    Landscape.openSimplifiedLandscapeModal($scope.draft.id).result.then(onLandscapeChanged)
                } else {
                    Landscape.openLandscape($scope.draft.id, display).then(onLandscapeChanged)
                }
            }

            $scope.isRequiredLandscapeDone = () => {
                return $scope.landscape.landscapeRequired === false || $scope.landscape.landscapeDone === true || $scope.draft.bulk_purchase
            }

            // SIMULATION
            const generateSimulationsPayload = function () {
                // { tempClass1: [a, b, ...], tempClass2: [x, y, ...] }
                //  => [{ tempClass1: a, tempClass2: x }, { tempClass1: b, tempClass2: y }, ...]
                const monthly = Object.keys($scope.cons[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]].monthly).reduce((acc, tempClass) => {
                    $scope.cons[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]].monthly[tempClass].forEach((cons, i) => {
                        if (!acc[i]) {
                            acc[i] = {}
                        }
                        acc[i][tempClass] = cons
                    })

                    return acc
                }, [])

                const simulation = {
                    provider_offer: $scope.draft.provider_offer,
                    addr_city_code: $scope.draft.addr_city_code,
                    id_p_calendar: $scope.draft.choosen_id_p_calendar || $scope.draft.id_p_calendar,
                    max_power: $scope.draft.choosen_max_power || $scope.draft.max_power,
                    id_ref_promo: $scope.draft.id_ref_promo,
                    cons: {
                        monthly,
                        timePeriod: $scope.cons[$scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]].timePeriod,
                    },
                }
                return {
                    simulationResult: Tariff.simulationV2(simulation).$promise,
                    refResult: Tariff.simulationV2(_.assign({}, simulation, { provider_offer: 'TRV_REF' })).$promise,
                    simulationMinus5: $scope.draft.providerOffer.has_pot && Tariff.simulationV2(_.assign({}, simulation, { reduction: -5 })).$promise,
                    simulationMinus10: $scope.draft.providerOffer.has_pot && Tariff.simulationV2(_.assign({}, simulation, { reduction: -10 })).$promise,
                    simulationMinus15: $scope.draft.providerOffer.has_pot && Tariff.simulationV2(_.assign({}, simulation, { reduction: -15 })).$promise,
                }
            }

            $scope.simulate = function () {
                $scope.saveSubscriptionPrice({})
                return $q.all(generateSimulationsPayload($scope.reduction.value)).then((data) => $scope.saveSubscriptionPrice(data)).catch(ErrorCatcher)
            }

            $scope.toggleShowTimetableGraph = () => {
                $scope.showTimetableGraph = !$scope.showTimetableGraph
            }

            // SLIDER
            $scope.reductionSliderOptions = {
                enforceStep: true,
                showTicks: true,
                showTicksValues: true,
                step: 5,
                floor: 5,
                ceil: 15,
                vertical: false,
                translate() { return '' },
            }

            $scope.reRenderSlider = () => {
                $timeout(() => $rootScope.$broadcast('rzSliderForceRender'))
            }

            // ESTIMATED TIMETABLE
            $scope.estimateTimetable = function () {
                $scope.fetchingEstimTt = true
                EstimateTimetableService.openModal($scope.draft, (result) => {
                    $scope.fetchingEstimTt = false
                })
            }

            // TIMELINE
            $scope.timeline = { default: [] }

            // TIMETABLE DATA TRANSFORMATION
            // Quotation second reading date locally => first reading date + 6 month
            // The idea is to hide price after second reading date
            const fetchSecondReadingDate = function (values) {
                const item = _.find(values, 'nextReading')
                return item ? moment({ year: item.year, month: item.month - 1 }).add(6, 'month') : moment.invalid()
            }

            const mapTimetableItemToGraphData = (draft, secondReadingDate) => function (item) {
                const momentDate = moment({ year: item.year, month: item.month - 1 })
                const amount = Math.floor(item.total * 100) / 100
                const yearly = Math.floor(item.yearly * 100) / 100
                const sleeked = Math.floor(item.sleeked * 100) / 100

                return {
                    date: momentDate.format('YYYY-MM-DD'),
                    billingDate: momentDate.format('MMMM YYYY').toLowerCase(),
                    amount,
                    yearly,
                    sleeked,
                    toDisplay: (draft.sleek_timetable) ? sleeked : yearly,
                    nextReading: _.get(item, 'nextReading', false) || secondReadingDate.isSame(momentDate, 'month'),
                    amountDisplay: !secondReadingDate.isValid() || momentDate.isBefore(secondReadingDate, 'month'),
                }
            }

            const timelineToGraphData = (draft, values) => _.map(values, mapTimetableItemToGraphData(draft, fetchSecondReadingDate(values))).slice(0, 12)

            const getTimelineForEstimator = (estimator) => {
                return TimetableGeneration.draftTimetableV2({ idContract: $scope.draft.id, estimator }, {}).$promise.then((data) => {
                    if (_.isEmpty(data)) {
                        AlertManager.error('Il n’y a pas d’échéancier pour le contrat')
                    } else {
                        const esti = estimator || ($scope.draft.bulk_purchase && $scope.PREFERRED_ESTIMATOR_MAPPING[$scope.draft.preferred_estimator]) || 'default'
                        $scope.timeline[esti] = timelineToGraphData($scope.draft, data)
                        return $scope.timeline[esti][1].yearly.toFixed(2)
                    }
                }).catch((error) => {
                    ErrorCatcher(error)
                    throw error
                })
            }

            const loadGraphData = () => {
                $scope.showTimetableGraph = !$scope.draft.sleek_timetable

                if ($scope.draft.bulk_purchase && !$scope.landscape.landscapeRequired) {
                    $q.all({
                        averaged: getTimelineForEstimator('averaged'),
                        declared: getTimelineForEstimator('declared'),
                        measure: getTimelineForEstimator('measure'),
                    }).then((estimators) => {
                        MetaWatcher.notif('SALES_TUNNEL.MODIFIED_ESTIMATED_EUROS', estimators)
                    })
                } else {
                    getTimelineForEstimator()
                }
            }

            MetaWatcher.watch('SALES_TUNNEL.MODIFIED_BILLING_MODALITY', 'salesTunnelQuotation', $scope, loadGraphData)

            $scope.$watch('simulations.simulationResult', (simulationResult) => {
                if (_.isEmpty(simulationResult)) {
                    $scope.timeline = { default: [] }
                } else {
                    loadGraphData()
                }
            })

            // FORM
            $scope.form = {}
            $scope.$watch('draft', (draft, previousDraft) => {
                $scope.form = {
                    sleek_timetable: _.get(draft, 'sleek_timetable'),
                    preferred_payment_day: _.get(draft, 'preferred_payment_day'),
                }
                if (!_.isEqual(draft.provider_offer, previousDraft.provider_offer)) {
                    $scope.estimate()
                }
            })

            const activate = () => {
                initComponentValidator()
                $scope.reRenderSlider()
            }
            return activate()
        },
    }))
